<template>
  <div class="Inspection3">
    <h1 id="heading">Bewertung der Personalsituation</h1>
    <v-divider></v-divider>
    <div>
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="items"
        item-key="name"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.assess }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.assess"
                :value="props.item.assess"
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
      
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspection3",
  props: ["assessmen"],
  data() {
    return {
      assessment: 0,
      assessName: "",
      assessHeader: "",
      dialog: false,
      items: [
        {
          name:
            "Technisches Personal ist während des Betriebs vor Ort verfügbar",
          assess: 0
        },
        {
          name: "Kein technisches, jedoch Überwachungspersonal verfügbar",
          assess: 1
        },
        { name: "Kein Personal vor Ort verfügbar", assess: 2 }
      ],
      headers: [
        {
          text: "Alle Arten von Anlagen",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Relative Bewertung", sortable: false, value: "assess" }
      ]
    };
  },
  methods: {
    nextPage() {
      switch (this.assessment) {
        case 0:
          this.assessName =
            "Technisches Personal ist während des Betriebs vor Ort verfügbar";
          break;
        case 1:
          this.assessName =
            "Kein technisches, jedoch Überwachungspersonal verfügbar";
          break;
        case 2:
          this.assessName = "Kein Personal vor Ort verfügbar";
          break;
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Personalsituation";

      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    },
    previousPage() {
      this.$emit("InspPrevious", true);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", false);
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style>
.Inspection3 {
  background-color: white;
  width: 70%;
  margin: 1% auto 0% auto;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.radioGroup {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30%;
}

.DataTable {
  width: 90%;
  margin-left: 5%;
}

#heading {
  font-size: 200%;
}
</style>
